import { ThreadCheckResponse } from '../types/thread';

/**
 * Service for checking email thread duplicates
 */
class ThreadService {
  private baseUrl: string;

  constructor() {
    // Use current origin to support both dev and production environments
    this.baseUrl = window.location.origin;
    console.log(`[THREAD_SERVICE] Initialized with baseUrl: ${this.baseUrl}`);
  }

  /**
   * Check which emails in a thread are already submitted
   * @param companyName - Company name
   * @param baseCollectionName - Base collection name of the tender
   * @param internetMessageIds - Array of internet message IDs to check
   * @returns Promise resolving to check response
   */
  async checkThreadDuplicates(
    companyName: string,
    baseCollectionName: string,
    internetMessageIds: string[]
  ): Promise<ThreadCheckResponse> {
    const normalizedCompanyName = String(companyName || "").trim();
    const normalizedBaseCollectionName = String(baseCollectionName || "").trim();
    const normalizedInternetMessageIds = internetMessageIds
      .map((id) => String(id || "").trim().replace(/^<+|>+$/g, "").toLowerCase())
      .filter(Boolean);

    console.log(`[THREAD_SERVICE] Checking ${normalizedInternetMessageIds.length} emails for duplicates`);

    try {
      const url = `${this.baseUrl}/api/outlook/check-thread`;
      console.log(`[THREAD_SERVICE] Request URL: ${url}`);

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          companyName: normalizedCompanyName,
          baseCollectionName: normalizedBaseCollectionName,
          internetMessageIds: normalizedInternetMessageIds
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.message || `HTTP ${response.status}: ${response.statusText}`
        );
      }

      const result: ThreadCheckResponse = await response.json();
      console.log(`[THREAD_SERVICE] ✅ Check complete: ${result.data.existingEmails.length} existing, ${result.data.newEmails.length} new`);

      return result;

    } catch (error) {
      console.error(`[THREAD_SERVICE] Error checking thread duplicates:`, error);
      throw error;
    }
  }
}

// Export singleton instance
export const threadService = new ThreadService();
export default threadService;
